export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11681.02b24a85.jpg";